import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";

/**
 * The standalone real-view route used to host its own Cesium + HUD stack. The
 * unified Replay tab on the flight detail page now covers the same workflow
 * (with configurable widgets, 2D toggle, fullscreen mode), so this route just
 * forwards there.
 */
export function RealReplayPage() {
  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    document.body.classList.add("real-replay-active");
    return () => document.body.classList.remove("real-replay-active");
  }, []);
  if (!id) return <Navigate to="/flights" replace />;
  return <Navigate to={`/flights/${id}?tab=replay`} replace />;
}
